import "@@/core/assets/css/print.css";
import { Printd } from "printd";
import configProvider from "@@/core/configProvider";
import styles from "../GetStyles";
import VueBarcode from "vue-barcode";

export default {
  name: "BarcodePrint",
  components: {
    barcode: VueBarcode,
  },
  data() {
    return {
      items: [],
      finalList: {},
      productName: "",
    };
  },

  mounted() {
    this.getVarieties(this.$route.query.id);
  },
  methods: {
    formatPrice(price) {  
            return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");  
        }, 
    adjustHeight(event) {  
      event.target.style.height = 'auto';
      event.target.style.height = `${event.target.scrollHeight}px`; 
  }, 
    print() {
      const d = new Printd();
      let _styles;
      if (configProvider.get("print_font")) {
        _styles =
          styles +
          "@font-face{font-family:'yekan-bakh';src:url(" +
          configProvider.get("print_font") +
          ") format('woff');font-weight:normal;font-style:normal;}";
      } else {
        _styles = styles;
      }
      d.print(document.getElementById("print"), [_styles]);
    },
    checkLabel(key) {
      if (key.includes("tarh")) {
        return "طرح:";
      } else if (key.includes("color")) {
        return "رنگ:";
      } else if (key.includes("size")) {
        return "سایز:";
      } else {
        return "model:";
      }
    },
    async getVarieties(id) {
      const response = await this.$axios.get("admin/store_transfers/" + id);
      this.items = response.data.data.items;
      this.$forceUpdate();
    },
  },
};
